<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
    persistent
  >
    <v-card rounded="lg">
      <v-card-text class="pt-3">
        <goods-map-form
          v-model="innerValue"
          :multi="multi"
          :already-onboard-goods="onboardGoods"
          ref="goodsForm"
          @submit="handleSubmit"
          v-if="dialog"
        />
      </v-card-text>

      <v-card-actions class="mt-0 pt-0 px-5 pb-3">
        <v-spacer></v-spacer>
        <v-btn text @click.native="cancel">{{ buttonFalseText }}</v-btn>
        <v-btn color="primary darken-1" class="px-5" outlined @click.native="agree">{{ buttonTrueText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Components
import GoodsMapForm from '@/components/forms/GoodsMapForm.vue'

// Component
export default {
  name: 'GoodsMapFormModal',
  components: {
    GoodsMapForm,
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    buttonTrueText: 'Salva',
    buttonFalseText: 'Annulla',
    options: {
      color: 'white',
      width: 680,
      zIndex: 200,
    },
    innerValue: null,
    multi: false,
    onboardGoods: null,
  }),
  methods: {
    open(data, multi, onboardGoods, options) {
      this.dialog = true
      this.options = Object.assign(this.options, options)
      this.innerValue = JSON.parse(JSON.stringify(data))
      this.multi = multi
      this.onboardGoods = onboardGoods || []

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    close() {
      this.innerValue = null
      this.dialog = false
    },
    handleSubmit(data) {
      this.resolve(JSON.parse(JSON.stringify(data)))

      this.$nextTick(() => {
        this.innerValue = null
        this.dialog = false
      })
    },
    async agree() {
      await this.$refs.goodsForm.submit()
    },
    cancel() {
      this.resolve(false)
      this.$nextTick(() => {
        this.innerValue = null
        this.dialog = false
      })
    },
  },
}
</script>
